/**
 * validador-cartao.js
 * Autor: ChatGPT (o3)
 * Uso: import { validarCartao } from './validador-cartao.js';
 *      const resultado = validarCartao('6036 8904 4774 9044');
 *      console.log(resultado);
 */

// -------------------- Funções utilitárias --------------------

/** Remove tudo que não for dígito */
function sanitizar(numero) {
    return String(numero).replace(/\D/g, '');
  }
  
  /** Algoritmo de Luhn: devolve true se o número é consistente */
  function luhnCheck(numeroLimpo) {
    let soma = 0;
    let par = false;
  
    // Percorre da direita para a esquerda
    for (let i = numeroLimpo.length - 1; i >= 0; i--) {
      let n = parseInt(numeroLimpo.charAt(i), 10);
  
      if (par) {
        n *= 2;
        if (n > 9) n -= 9;
      }
  
      soma += n;
      par = !par;
    }
  
    return soma % 10 === 0;
  }
  
  // -------------------- Identificação de bandeira --------------------
  
  /** Mapeamento de bandeiras para seus padrões de BIN/regex */
  const BANDEIRAS = [
    {
      nome: 'Visa',
      regex: /^4\d{12}(\d{3})?(\d{3})?$/ // 13, 16 ou 19 dígitos
    },
    {
      nome: 'Mastercard',
      regex: /^(5[1-5]\d{14}|2(2[2-9]\d{12}|[3-6]\d{13}|7([01]\d{12}|20\d{12})))$/
    },
    {
      nome: 'American Express',
      regex: /^3[47]\d{13}$/ // 15 dígitos
    },
    {
      nome: 'Diners Club',
      regex: /^3(0[0-5]\d{11}|[68]\d{12})$/ // 14 dígitos
    },
    {
      nome: 'Discover',
      regex: /^6(?:011|22\d{2}|4[4-9]\d|5\d{2})\d{12}$/ // 16 dígitos
    },
    {
      nome: 'Elo',
      // Principais faixas usadas no Brasil (16 dígitos)
      regex: /^(4011(78|79)\d{10}|431274\d{10}|438935\d{10}|451416\d{10}|457(393|631|632)\d{9}|504175\d{10}|506(699|7\d{2})\d{10}|509\d{13}|627780\d{10}|636297\d{10}|636368\d{10}|650\d{13}|651\d{13}|652\d{13}|655\d{13})$/
    },
    {
      nome: 'Hipercard',
      regex: /^(606282\d{10}(\d{3})?|3841(?:0|4)0\d{13})$/ // 16 ou 19
    },
    {
      nome: 'Hiper',
      regex: /^(637095|637568|637599)\d{10}$/ // 16
    },
    {
      nome: 'Aura',
      regex: /^50\d{14}$/ // 16
    }
  ];
  
  /** Retorna a bandeira ou null se não reconhecida */
  function identificarBandeira(numeroLimpo) {
    for (const bandeira of BANDEIRAS) {
      if (bandeira.regex.test(numeroLimpo)) {
        return bandeira.nome;
      }
    }
    return null;
  }
  
  // -------------------- Função principal --------------------
  
  /**
   * Valida um número de cartão de crédito.
   * @param {string|number} numero Número informado (pode conter espaços ou hífens)
   * @returns {{ valido: boolean, bandeira: string|null, mensagem: string }}
   */
  export function validarCartao(numero) {
    const limpo = sanitizar(numero);
  
    if (limpo.length < 13 || limpo.length > 19) {
      return {
        valido: false,
        bandeira: null,
        mensagem: 'Quantidade de dígitos fora do intervalo permitido (13-19).'
      };
    }
  
    let bandeira = identificarBandeira(limpo);
  
    if (!bandeira) {
        bandeira = '';
      // return {
      //   valido: false,
      //   bandeira: null,
      //   mensagem: 'Bandeira não reconhecida ou não suportada.'
      // };
    }
  
    if (!luhnCheck(limpo)) {
      return {
        valido: false,
        bandeira,
        mensagem: 'Número inválido'
      };
    }
  
    return {
      valido: true,
      bandeira,
      mensagem: 'Cartão válido!'
    };
  }
  
  // -------------------- Exemplo de uso (browser/Node) --------------------
  // Descomente para testar diretamente:
  //
  // const teste = [
  //   '4111 1111 1111 1111', // Visa
  //   '5105 1051 0510 5100', // Mastercard
  //   '6036 8904 4774 9044', // Hipercard (exemplo acima)
  //   '1234 5678 9012 3456'  // inválido
  // ];
  //
  // teste.forEach(n => console.log(n, validarCartao(n)));
  